// src/pages/admin/Categories.jsx
import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CrudPage from '../../components/admin/CrudPage';
import { medicineAPI } from '../../services/api';

const Form = ({ form, onChange }) => (
  <>
    <div className="form-group">
      <label className="form-label required">Category Name</label>
      <input className="form-input" name="name" value={form.name || ''} onChange={onChange} placeholder="e.g. Antibiotic" required />
    </div>
    <div className="form-group">
      <label className="form-label">Description</label>
      <textarea className="form-textarea" name="description" value={form.description || ''} onChange={onChange} placeholder="Optional description…" />
    </div>
  </>
);

export default function Categories() {
  return (
    <AdminLayout title="Categories">
      <CrudPage
        title="Categories"
        subtitle="Manage top-level medicine categories"
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'description', label: 'Description' },
          { key: 'created_on', label: 'Created', render: r => new Date(r.created_on).toLocaleDateString() },
        ]}
        fetchFn={medicineAPI.getCategories}
        createFn={medicineAPI.createCategory}
        updateFn={medicineAPI.updateCategory}
        deleteFn={medicineAPI.deleteCategory}
        FormComponent={Form}
        formDefault={{ name: '', description: '' }}
      />
    </AdminLayout>
  );
}
